/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowFigureACircleRightIcon16Light } from './ArrowFigureACircleRightIcon16Light';
import { ArrowFigureACircleRightIcon16Regular } from './ArrowFigureACircleRightIcon16Regular';
import { ArrowFigureACircleRightIcon16Solid } from './ArrowFigureACircleRightIcon16Solid';
import { ArrowFigureACircleRightIcon20Light } from './ArrowFigureACircleRightIcon20Light';
import { ArrowFigureACircleRightIcon20Regular } from './ArrowFigureACircleRightIcon20Regular';
import { ArrowFigureACircleRightIcon20Solid } from './ArrowFigureACircleRightIcon20Solid';
import { ArrowFigureACircleRightIcon24Regular } from './ArrowFigureACircleRightIcon24Regular';
import { ArrowFigureACircleRightIcon24Solid } from './ArrowFigureACircleRightIcon24Solid';
import { ArrowFigureACircleRightIcon32Regular } from './ArrowFigureACircleRightIcon32Regular';
import { ArrowFigureACircleRightIcon64Regular } from './ArrowFigureACircleRightIcon64Regular';
var sizes = {
    16: {
        light: ArrowFigureACircleRightIcon16Light,
        regular: ArrowFigureACircleRightIcon16Regular,
        solid: ArrowFigureACircleRightIcon16Solid,
    },
    20: {
        light: ArrowFigureACircleRightIcon20Light,
        regular: ArrowFigureACircleRightIcon20Regular,
        solid: ArrowFigureACircleRightIcon20Solid,
    },
    24: {
        regular: ArrowFigureACircleRightIcon24Regular,
        solid: ArrowFigureACircleRightIcon24Solid,
    },
    32: {
        regular: ArrowFigureACircleRightIcon32Regular,
    },
    64: {
        regular: ArrowFigureACircleRightIcon64Regular,
    },
};
export var ArrowFigureACircleRightIcon = forwardRef('ArrowFigureACircleRightIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
